import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Card as AntCard } from 'antd';
import type { CardProps as AntCardProps } from 'antd';
import { colorsPalette } from '../../styles/colors-palette';

interface CardWithIconProps extends AntCardProps {
  icon?: ReactElement;
  img?: never;
}
interface CardWithImgProps extends AntCardProps {
  img?: string;
  icon?: never;
}

interface CustomStyles {
  flex?: React.CSSProperties['flex'];
  height?: CSSSize;
  width?: CSSSize;
  imgHeight?: CSSSize;
  imgWidth?: CSSSize;
  maxWidth?: CSSSize;
  minWidth?: CSSSize;
  background?: string;
  borderRadius?: CSSSize;
  borderColor?: string;
  visibility?: React.CSSProperties['visibility'];
  cursor?: React.CSSProperties['cursor'];
  hoverColor?: string;
}

type CardProps = (CardWithIconProps | CardWithImgProps) & {
  customstyles?: CustomStyles;
  footer?: ReactElement;
};

// TODO rename this maza*aka
function Card({
  children,
  className,
  img,
  icon,
  customstyles,
  footer,
  ...rest
}: CardProps): ReactElement {
  return (
    <StyledCard {...rest} className={className} customstyles={customstyles}>
      <WrapperContent>
        {img && (
          <Img
            src={img}
            style={{ height: customstyles?.imgHeight, width: customstyles?.imgWidth }}
          />
        )}
        {icon && icon}
        {children}
      </WrapperContent>
      {footer && footer}
    </StyledCard>
  );
}

const StyledCard = styled(AntCard)<{ customstyles?: CustomStyles }>`
  flex: ${props => props.customstyles?.flex};
  height: ${props => props.customstyles?.height};
  width: ${props => props.customstyles?.width};
  max-width: ${props => props.customstyles?.maxWidth};
  min-width: ${props => props.customstyles?.minWidth};
  background: ${props => props.customstyles?.background};
  border-radius: ${props => props.customstyles?.borderRadius};
  border-color: ${props => props.customstyles?.borderColor};
  visibility: ${props => props.customstyles?.visibility};

  cursor: ${props => props.customstyles?.cursor};
  &:hover {
    background: ${props => props.customstyles?.hoverColor};
  }

  .ant-card-body {
    height: 100%;
  }
`;

const WrapperContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  height: 100%;
`;

const Img = styled.img``;

export { Card };
